export default {
  "b2b.message.empty.items": "Nebyly nalezeny žádné záznamy",
  "b2b.components.not-found": "Tak toto tu nemáme, zkuste něco jiného"
};
